﻿"use strict";
export function toggleMenu() {
    jQuery(".headerButtons-menu, .menuResponsive-cover, .menuResponsive-close").click(function () {
        var menu_status = false;
        var menu = jQuery(".menuResponsive");
        var menu_back = jQuery(".menuResponsive-cover");
        var menu_inner = jQuery(".menuResponsive-inner");
        var body_inner = jQuery(".body-inner");
        var body = jQuery("body");
        var duration = 200;
        menu_status = jQuery(".menuResponsive").hasClass("active");

        if (jQuery(this).hasClass(".menuResponsive-cover") || jQuery(this).hasClass(".menuResponsive-close")) {
            menu_status = true;
        }

        if (!menu_status) {
            menu.addClass("active");
            menu.css("display", "block");
            body.css("overflow", "hidden");

            jQuery(menu_inner).animate({
                left: "+=280"
            }, duration, function () { });

            jQuery(menu_back).animate({
                opacity: 0.4
            }, duration, function () { });
        }
        else {
            jQuery(menu_inner).animate({
                left: "-=280"
            }, duration, function () { });

            jQuery(menu_back).animate({
                opacity: 0
            }, duration, function () {
                menu.css("display", "");
                menu.removeClass("active");
                body.css("overflow", "");
            });

        }
    });
}